/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ClothesOuterTshirtIcon16Light } from './ClothesOuterTshirtIcon16Light';
import { ClothesOuterTshirtIcon16Regular } from './ClothesOuterTshirtIcon16Regular';
import { ClothesOuterTshirtIcon16Solid } from './ClothesOuterTshirtIcon16Solid';
import { ClothesOuterTshirtIcon20Light } from './ClothesOuterTshirtIcon20Light';
import { ClothesOuterTshirtIcon20Regular } from './ClothesOuterTshirtIcon20Regular';
import { ClothesOuterTshirtIcon20Solid } from './ClothesOuterTshirtIcon20Solid';
import { ClothesOuterTshirtIcon24Regular } from './ClothesOuterTshirtIcon24Regular';
import { ClothesOuterTshirtIcon24Solid } from './ClothesOuterTshirtIcon24Solid';
import { ClothesOuterTshirtIcon32Regular } from './ClothesOuterTshirtIcon32Regular';
import { ClothesOuterTshirtIcon64Regular } from './ClothesOuterTshirtIcon64Regular';
var sizes = {
    16: {
        light: ClothesOuterTshirtIcon16Light,
        regular: ClothesOuterTshirtIcon16Regular,
        solid: ClothesOuterTshirtIcon16Solid,
    },
    20: {
        light: ClothesOuterTshirtIcon20Light,
        regular: ClothesOuterTshirtIcon20Regular,
        solid: ClothesOuterTshirtIcon20Solid,
    },
    24: {
        regular: ClothesOuterTshirtIcon24Regular,
        solid: ClothesOuterTshirtIcon24Solid,
    },
    32: {
        regular: ClothesOuterTshirtIcon32Regular,
    },
    64: {
        regular: ClothesOuterTshirtIcon64Regular,
    },
};
export var ClothesOuterTshirtIcon = forwardRef('ClothesOuterTshirtIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
